import React, { useState, useEffect } from 'react';
import { Eye, Code, Smartphone, Figma, Gamepad2, Puzzle } from 'lucide-react';
import styles from './AllProjects.module.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import portfolio1 from '../../images/portfolio-1.jpg';
import portfolio2 from '../../images/portfolio-2.jpg';
import portfolio3 from '../../images/grid-plugin.png';
import portfolio4 from '../../images/feedback.png';
import portfolio5 from '../../images/portfolio-4.jpg';
import portfolio6 from '../../images/gallery-plugin.png';
import portfolio7 from '../../images/portfolio-8.jpg';
import portfolio8 from '../../images/portfolio-9.jpg';
import portfolio9 from '../../images/portfolio-10.jpg';
import portfolio10 from '../../images/portfolio-11.jpg';
import portfolio11 from '../../images/portfolio-7.jpg';
import portfolio12 from '../../images/portfolio-12.jpg';
import portfolio13 from '../../images/portfolio-13.jpg';
import portfolio14 from '../../images/portfolio-14.jpg';
import portfolio15 from '../../images/portfolio-15.jpg';
import portfolio16 from '../../images/Nameplacething-Header.jpg';
import portfolio17 from '../../images/drawing-app-1.png';
import portfolio18 from '../../images/king-1.png';
import portfolio19 from '../../images/portfolio-3.jpg'
import portfolio20 from '../../images/portfolio-5.jpg'
import portfolio21 from '../../images/portfolio-6.jpg'

const AllProjects = () => {
  const [activeTab, setActiveTab] = useState('web');
  const [mode, setMode] = useState('web');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const categories = [
    { id: 'web', name: 'Web Design', icon: Code, color: '#06b6d4' },
    { id: 'plugins', name: 'Plugins', icon: Puzzle, color: '#10b981' },
    { id: 'flutter', name: 'Flutter', icon: Smartphone, color: '#3b82f6' },
    { id: 'figma', name: 'Figma', icon: Figma, color: '#a855f7' },
    { id: 'games', name: 'Games', icon: Gamepad2, color: '#f59e0b' }
  ];

  const projects = {
    web: [
      { id: 1, title: 'Web & Marketing', category: 'Wordpress', image: portfolio1, link: '/web-marketing' },
      { id: 2, title: 'ERP System', category: 'Wordpress', image: portfolio2, link: '/erp-system' },
      { id: 3, title: 'Ecommerce', category: 'Wordpress', image: portfolio19, link: '/ecommerce' },
      { id: 4, title: 'AI Solutions', category: 'Svelte & Tailwind', image: portfolio20, link: '/ai-solutions' },
      { id: 5, title: 'Food Ordering Service', category: 'Wordpress', image: portfolio5, link: '/food-ordering' },
      { id: 6, title: 'Food Brand', category: 'Angular & MongoDB', image: portfolio21, link: '/food-brand' },
      { id: 7, title: 'Hotel Booking', category: 'Angular & MongoDB', image: portfolio7, link: '/hotel-booking' },
      { id: 8, title: 'Dental Service', category: 'Angular & MongoDB', image: portfolio8, link: '/dental-service' },
      { id: 9, title: 'Healthcare Service', category: 'Angular & MongoDB', image: portfolio9, link: '/healthcare-service' },
      { id: 10, title: 'Technology Service', category: 'Angular & MongoDB', image: portfolio13, link: '/technology-service' },
      { id: 11, title: 'Integration Platform', category: 'Angular & MongoDB', image: portfolio12, link: '/integration-platform' },
      { id: 12, title: 'Real Estate', category: 'Angular & MongoDB', image: portfolio10, link: '/real-estate' },
    ],
    plugins: [
      { id: 20, title: 'Grid Plugin', category: 'WordPress Plugin', image: portfolio3, link: '/gridplugin' },
      { id: 21, title: 'Feedback Plugin', category: 'WordPress Plugin', image: portfolio4, link: '/feedbackplugin' },
      { id: 22, title: 'Masonry Gallery Plugin', category: 'WordPress Plugin', image: portfolio6, link: '/masonrygallery' },
    ],
    flutter: [
      { id: 7, title: 'Student Education App', category: 'Flutter & Firebase', image: portfolio11, link: '/flutter' },
    ],
    figma: [
      { id: 13, title: 'Farmsmojo Mobile App', category: 'Component Library', image: portfolio14, link: '/farmsmojo-app' },
      { id: 14, title: 'Amore Dating App', category: 'iOS & Android', image: portfolio15, link: '/dating-app' },
    ],
    games: [
      { id: 15, title: 'Name Place Animal Thing', category: 'Multiplayer Game', image: portfolio16, link: '/nameplacething' },
      { id: 17, title: 'Guess The Image', category: 'Multiplayer Drawing Game', image: portfolio17, link: '/guess-the-image' },
      { id: 19, title: 'KingsCourt', category: 'Multiplayer Card Game', image: portfolio18, link: '/kingscourt' },
    ]
  };

  const handleCardClick = (link) => {
    window.location.href = link;
  };

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      <div className={styles.container}>
      <div className={styles.backgroundGradient}>
        <div className={styles.gradientOrb1}></div>
        <div className={styles.gradientOrb2}></div>
        <div className={styles.gradientOrb3}></div>
      </div>

      <div className={styles.contentWrapper}>
        <section className={styles.section}>
          <div className={styles.header}>
            <h1 className={styles.title}>All Projects</h1>
            <p className={styles.subtitle}>Explore my complete portfolio across different platforms</p>
          </div>

          {/* Intro Section */}
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <p className={styles.introText}>
                Over the years, I've architected and developed comprehensive digital solutions for diverse industries, 
                creating robust web platforms that serve thousands of users daily. My portfolio includes enterprise-level 
                projects like <span className={styles.highlight}>erasmith.com</span>, <span className={styles.highlight}>hyphen.software.com</span>, 
                and government portals such as <span className={styles.highlight}>e-nirmit.cpwd.gov.in</span>. From e-commerce 
                platforms like <span className={styles.highlight}>farmsmojo.com</span> and <span className={styles.highlight}>orbitalfood.digiko.in</span> 
                to AI-powered solutions at <span className={styles.highlight}>aicollaborate.ai</span>, healthcare platforms 
                including <span className={styles.highlight}>thewhitedental.com</span> and <span className={styles.highlight}>drarpanaharitwal.com</span>, 
                and business automation systems like <span className={styles.highlight}>allianceautomation.com</span> and 
                <span className={styles.highlight}>3ehpl.com</span>—each project represents a unique challenge solved through 
                innovative technology and user-centered design. These aren't just websites; they're digital ecosystems 
                that drive business growth and enhance user experiences across multiple domains.
              </p>
            </div>
            <div className={styles.floatingShapes}>
              <div className={styles.shape1}></div>
              <div className={styles.shape2}></div>
              <div className={styles.shape3}></div>
            </div>
          </div>
          
          {/* Tabs */}
          <div className={styles.tabContainer}>
            {categories.map((cat) => {
              const Icon = cat.icon;
              return (
                <button
                  key={cat.id}
                  onClick={() => setActiveTab(cat.id)}
                  className={`${styles.tab} ${activeTab === cat.id ? styles.tabActive : ''}`}
                  style={{
                    '--tab-color': cat.color
                  }}
                >
                  <Icon size={20} />
                  <span>{cat.name}</span>
                  <div className={styles.tabIndicator}></div>
                </button>
              );
            })}
          </div>

          {/* Project Cards */}
          <div className={styles.projectsWrapper}>
            {categories.map((cat) => (
              <div
                key={cat.id}
                className={`${styles.projectsGrid} ${activeTab === cat.id ? styles.projectsActive : ''}`}
              >
                {projects[cat.id].map((project, index) => (
                  <div
                    key={project.id}
                    className={styles.card}
                    onClick={() => handleCardClick(project.link)}
                    style={{
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <div 
                      className={styles.cardImage}
                      style={{ backgroundImage: `url(${project.image})` }}
                    >
                      <div className={styles.imageOverlay}></div>
                    </div>
                    <div className={styles.cardOverlay}>
                      <span className={styles.overlayTitle}>{project.title}</span>
                      <span className={styles.overlayArrow}>→</span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
    <div className={styles.footerOverride}>
        <Footer  />
      </div>
    </>
  );
};

export default AllProjects;